import axios from 'axios';

const setupAxios = (navigate) => {
    // Request Interceptor: Add Token to Headers
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem('token');
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    // Response Interceptor: Handle 401 (Unauthorized/Expired)
    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response && error.response.status === 401) {
                const currentPath = window.location.pathname;
                // Don't redirect if already on Login or Root
                if (currentPath !== '/Login' && currentPath !== '/') {
                    alert('세션이 만료되었습니다. 다시 로그인해주세요.');
                    // A dead guest token would otherwise be reused by "지금 시작하기" forever
                    if (localStorage.getItem('token') === localStorage.getItem('guest_token')) localStorage.removeItem('guest_token');
                    localStorage.removeItem('token');
                    localStorage.removeItem('user_email');
                    window.location.href = '/Login'; // Use window.location as it's outside React components
                }
            }
            return Promise.reject(error);
        }
    );
};

export default setupAxios;
